"use client";

import { Link, NavLink, Outlet /*, useNavigate*/ } from "react-router-dom";
import d1 from "../logo/logo.jpeg";
import { Divider } from "@chakra-ui/react";
import { useState, useEffect /*, useRef*/ } from "react";

const JOBLIST_PERSIST_KEY = "jobListPersist";

export function Dummy() {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Jobs dropdown state (currently not in use)
  // const [isJobsDropdownOpen, setJobsDropdownOpen] = useState(false);
  // const [activeSubMenu, setActiveSubMenu] = useState<string | null>(null);

  // Dropdown refs (currently not in use)
  // const dropdownRef = useRef<HTMLDivElement | null>(null);
  // const timeoutRef = useRef<number | null>(null);

  // const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
    document.body.style.overflow = !isSidebarOpen ? "hidden" : "auto";
  };

  // Hover handlers with delay for jobs dropdown (currently not in use)
  /*
  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setJobsDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = window.setTimeout(() => {
      setJobsDropdownOpen(false);
      setActiveSubMenu(null); // Also close sub-menu
    }, 300);
  };
  */

  // Close dropdown when clicking outside (currently not in use)
  /*
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setJobsDropdownOpen(false);
        setActiveSubMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  */

  // --- Job Data & helpers for dropdown (currently not in use) ---
  /*
  const jobTypes = [
    { value: "", label: "All Types" },
    { value: "Full Time", label: "Full Time" },
    { value: "Part Time", label: "Part Time" },
    { value: "Contract", label: "Contract" },
    { value: "Freelance", label: "Freelance" },
    { value: "Internship", label: "Internship" },
  ];

  const jobCategories = [
    { uuid: "6ab5013c-3524-4722-bf5f-e3f4ff35f93c", title: "Administrative & Management" },
    { uuid: "2f8fd065-b087-4438-92eb-6f219085be6e", title: "Customer Service" },
    { uuid: "2728c84a-a63d-46d5-b232-56bcb6373f52", title: "Finance & Accounting" },
    { uuid: "1a07d165-d156-4ca7-a2db-79c3be3c9825", title: "Human Resources (HR)" },
    { uuid: "b7883338-3b1a-4ea4-84f3-54a60c684367", title: "IT (Information Technology)" },
    { uuid: "14a5e1ed-460e-46ff-8cc9-cf8f46f0599c", title: "Legal & Compliance" },
    { uuid: "56ba641b-a11c-4c1c-ba64-c5db036536a9", title: "Marketing & Sales" },
    { uuid: "71ae4164-76d6-4f64-8dde-18dcf78b1997", title: "Operations & Production" },
    { uuid: "7a7b17b9-b3f1-4b7d-95f1-5597d911a641", title: "Others" },
    { uuid: "91ac3933-99f2-4d4f-8415-db9aa23ce591", title: "Public Relations (PR) & Communications" },
    { uuid: "091aad8c-5986-4251-a75f-e6d1f59731d1", title: "Research & Development (R&D)" },
  ];

  const jobLocations = [
    { uuid: "d9633067-a577-11ef-806e-89fb4f970b6e", title: "Bhopal" },
    { uuid: "d963424e-a577-11ef-806e-89fb4f970b6e", title: "Indore" },
    { uuid: "d963b72d-a577-11ef-806e-89fb4f970b6e", title: "Pune" },
    { uuid: "d96561b3-a577-11ef-806e-89fb4f970b6e", title: "Hyderabad" },
    { uuid: "d9659213-a577-11ef-806e-89fb4f970b6e", title: "Noida" },
    { uuid: "d9655bab-a577-11ef-806e-89fb4f970b6e", title: "Greater Noida" },
    { uuid: "d9621041-a577-11ef-806e-89fb4f970b6e", title: "Ahmedabad" },
    { uuid: "d962b588-a577-11ef-806e-89fb4f970b6e", title: "Bengaluru" },
    { uuid: "d9647349-a577-11ef-806e-89fb4f970b6e", title: "Chennai" },
    { uuid: "d963ac49-a577-11ef-806e-89fb4f970b6e", title: "Mumbai" },
    { uuid: "d964377a-a577-11ef-806e-89fb4f970b6e", title: "Jaipur" },
  ];

  const jobTitles = [
    { uuid: "31afdd79-fe5a-47d5-90c8-4f6fdd39c12e", title: "Software Developer" },
    { uuid: "041fe998-cbb8-483c-885a-9c01d1c2ca8d", title: "Full Stack Developer" },
    { uuid: "87daaf1c-a54f-4b60-acd6-5f4448790a94", title: "Android Developer" },
    { uuid: "c2ba9d18-6904-490f-99d2-917486506903", title: "iOS Developer" },
    { uuid: "96f9c59e-72e6-43dc-92d9-5a7802272ba2", title: "UI/UX Designer" },
    { uuid: "1c1bc246-3907-4789-a118-eb1b079364c5", title: "AI / Machine Learning Related" },
    { uuid: "b076e802-00c4-45e1-9a86-7e8ec17b5290", title: "Cloud Consultant (Oracle Cloud)" },
    { uuid: "00f280a5-c10f-4863-99a8-91ac9c00769d", title: "Digital Marketing Executive" },
    { uuid: "975a79c2-104b-4ac8-8e9d-8f723e1b2137", title: "HR Manager" },
    { uuid: "c8424ea1-7304-4de2-9184-cb283f6a5f72", title: "Project / Program Manager" },
  ];

  // Navigate to /jobs with state that JobList understands
  const handleJobSelection = (type: string, value: string, title?: string) => {
    try {
      sessionStorage.removeItem(JOBLIST_PERSIST_KEY);
    } catch (e) {}

    const state: any = { fromJobSearch: true };

    switch (type) {
      case "type":
        state.jobType = value || "";
        break;
      case "location":
        if (value) {
          state.selectedLocations = [value];
          if (title) state.locationLabelMap = { [value]: title };
        }
        break;
      case "title":
        if (value) {
          state.selectedSuggestions = [{ uuid: `jt_${value}`, title: title || "" }];
        }
        break;
      case "category":
        if (value) {
          state.departmentUuid = value;
          state.selectedSuggestions = [];
        }
        break;
      default:
        break;
    }

    navigate("/jobs", { state });
    setJobsDropdownOpen(false);
    setActiveSubMenu(null);
  };

  // Helper component for sub-menu lists
  const renderSubMenuList = (title: string, items: any[], type: string) => (
    <>
      <h3 className="text-sm font-semibold text-gray-900 mb-3 pb-2 border-b border-gray-200">{title}</h3>
      <div className="space-y-1">
        {items.map((item) => (
          <button
            key={item.uuid || item.value}
            onClick={() => handleJobSelection(type, item.uuid || item.value, item.title || item.label)}
            className="block w-full text-left px-2 py-1.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded transition-colors"
          >
            {item.title || item.label}
          </button>
        ))}
      </div>
    </>
  );
  */

  const navLinkDesktop = ({ isActive }: { isActive: boolean }) =>
    `relative inline-block py-1 font-medium transition-colors duration-200 text-gray-700 hover:text-blue-600 after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-0.5 after:bg-yellow-400 after:transition-all after:duration-300 after:w-0 hover:after:w-full ${isActive ? "text-blue-600 after:w-full" : ""
    }`;

  const navLinkMobile = ({ isActive }: { isActive: boolean }) =>
    `relative px-4 py-3 rounded-lg font-medium transition-colors duration-200 text-gray-700 hover:bg-gray-50 hover:text-blue-600 after:content-[''] after:absolute after:left-4 after:bottom-2 after:h-0.5 after:bg-yellow-400 after:transition-all after:duration-300 after:w-0 hover:after:w-[calc(100%-2rem)] ${isActive ? "text-blue-600 after:w-[calc(100%-2rem)]" : ""
    }`;

  return (
    <div className="min-h-screen flex flex-col">
      <header
        className={`sticky top-0 z-30 w-full transition-all duration-300 ${scrolled ? "bg-white shadow-sm" : "bg-white"
          }`}
      >
        <nav className="px-4 py-2 lg:px-8 lg:py-3 w-full">
          <div className="flex items-center justify-between mx-auto min-w-7xl">
            {/* Logo */}
            <div className="flex-shrink-0 w-32 md:w-40">
              <Link to="/" className="block">
                <img src={d1} className="object-contain h-full w-full" alt="Logo" />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden custom:flex items-center space-x-8 font-medium text-gray-700">
              <NavLink to="/" end className={navLinkDesktop}>
                Home
              </NavLink>

              {/* Simple "Find Job" link (dropdown disabled) */}
              <NavLink to="/jobs" className={navLinkDesktop}>
                Find Job
              </NavLink>

              {/* Jobs Dropdown (disabled for now).
                  To re-enable, uncomment this block AND all related
                  state/hooks/data/helpers above. */}
              {/*
              <div
                ref={dropdownRef}
                className="jobs-dropdown-container relative"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <NavLink to="/jobs">
                  <button className="relative inline-block py-1 font-medium transition-colors duration-200 text-gray-700 hover:text-blue-600 after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-0.5 after:bg-yellow-400 after:transition-all after:duration-300 after:w-0 hover:after:w-full focus:outline-none flex items-center">
                    Find Job
                    <svg
                      className={`ml-1 w-4 h-4 transition-transform ${
                        isJobsDropdownOpen ? "rotate-180" : ""
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>
                </NavLink>

                {isJobsDropdownOpen && (
                  <div
                    className="absolute top-full left-0 mt-2 bg-white rounded-lg shadow-xl border border-gray-200 z-40"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <div className="flex relative">
                      <div className="p-4 min-w-[200px]">
                        <h3 className="text-sm font-semibold text-gray-900 mb-3 pb-2 border-b border-gray-200">
                          Job by Type
                        </h3>
                        <div className="space-y-1">
                          {jobTypes.map((type) => (
                            <button
                              key={type.value}
                              onClick={() => handleJobSelection("type", type.value, type.label)}
                              className="block w-full text-left px-2 py-1.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded transition-colors"
                            >
                              {type.label}
                            </button>
                          ))}
                        </div>
                      </div>

                      <div className="p-4 min-w-[240px] border-l border-gray-200 space-y-1">
                        {[
                          { key: "category", label: "Job by Category" },
                          { key: "location", label: "Job by Location" },
                          { key: "title", label: "Job by Title" },
                        ].map((item) => (
                          <div
                            key={item.key}
                            onMouseEnter={() => setActiveSubMenu(item.key)}
                            className={`flex justify-between items-center w-full text-left p-2 text-sm text-gray-700 rounded transition-colors cursor-pointer ${
                              activeSubMenu === item.key
                                ? "bg-blue-50 text-blue-600"
                                : "hover:bg-gray-100"
                            }`}
                          >
                            <span>{item.label}</span>
                            <svg
                              className="w-4 h-4 text-gray-400"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M9 5l7 7-7 7"
                              ></path>
                            </svg>
                          </div>
                        ))}
                      </div>

                      {activeSubMenu && (
                        <div className="absolute top-0 left-full h-full">
                          <div className="p-4 min-w-[300px] bg-white rounded-lg shadow-xl border-l ml-2 border-t border-b border-gray-200 overflow-y-auto">
                            {activeSubMenu === "category" &&
                              renderSubMenuList("Job by Category", jobCategories, "category")}
                            {activeSubMenu === "location" &&
                              renderSubMenuList("Job by Location", jobLocations, "location")}
                            {activeSubMenu === "title" &&
                              renderSubMenuList("Job by Title", jobTitles, "title")}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              */}

              <NavLink to="/company-list" className={navLinkDesktop}>
                Companies
              </NavLink>
              {/* <NavLink to="/pricing" className={navLinkDesktop}>
                Pricing
              </NavLink> */}
              <NavLink to="/resume-builder" className={navLinkDesktop}>
                Resume Builder
              </NavLink>
            </div>

            {/* Mobile menu button */}
            <div className="custom:hidden">
              <button
                onClick={toggleSidebar}
                type="button"
                className="p-2 rounded-lg text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-300 transition"
                aria-expanded={isSidebarOpen}
              >
                <span className="sr-only">Toggle navigation</span>
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {!isSidebarOpen ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  )}
                </svg>
              </button>
            </div>

            {/* Login/Signup & Employer Login Buttons */}
            <div className="hidden custom:flex items-center space-x-2">
              <Link
                to="/login"
                className="px-3 py-2 border border-gray-300 rounded-lg font-medium text-sm text-blue-600 hover:bg-gray-50 transition"
              >
                Candidate Login
              </Link>
              <button
                onClick={() =>
                  window.open("http://employer.indiahirings.com", "_blank", "noopener,noreferrer")
                }
                className="px-3 py-2 bg-blue-600 text-white text-sm rounded-lg font-medium hover:bg-blue-700 transition"
              >
                Employer Login
              </button>
            </div>
          </div>
        </nav>

        {/* Mobile Sidebar */}
        <div
          className={`fixed inset-0 z-50 transition-opacity ${isSidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
        >
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-gray-800 bg-opacity-50 backdrop-blur-sm"
            onClick={toggleSidebar}
          ></div>

          {/* Sidebar Panel */}
          <div
            className={`absolute top-0 left-0 w-4/5 max-w-xs h-full bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"
              }`}
          >
            <div className="flex flex-col h-full overflow-y-auto">
              {/* Sidebar Header */}
              <div className="flex items-center justify-between p-4 border-b">
                <div className="w-32 ">
                  <img src={d1} className="object-contain h-12 w-full" alt="Logo" />
                </div>
                <button
                  onClick={toggleSidebar}
                  className="p-2 rounded-full text-gray-500 hover:bg-gray-100 focus:outline-none"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              {/* Navigation Links */}
              <div className="py-2 px-4">
                <nav className="flex flex-col space-y-0">
                  <NavLink to="/" end onClick={toggleSidebar} className={navLinkMobile}>
                    Home
                  </NavLink>
                  <NavLink to="/jobs" onClick={toggleSidebar} className={navLinkMobile}>
                    Find Job
                  </NavLink>
                  <NavLink to="/company-list" onClick={toggleSidebar} className={navLinkMobile}>
                    Companies
                  </NavLink>
                  <NavLink to="/pricing" onClick={toggleSidebar} className={navLinkMobile}>
                    Pricing
                  </NavLink>
                  <NavLink to="/resume-builder" onClick={toggleSidebar} className={navLinkMobile}>
                    Resume Builder
                  </NavLink>
                </nav>
              </div>

              <Divider className="my-2" />

              {/* Auth Buttons */}
              <div className="px-4 py-2 space-y-3">
                <Link
                  to="/login"
                  onClick={toggleSidebar}
                  className="block w-full py-2.5 px-4 text-center border border-gray-300 rounded-lg text-blue-600 font-medium hover:bg-gray-50 transition"
                >
                  Log in
                </Link>
                <Link
                  to="/signup"
                  onClick={toggleSidebar}
                  className="block w-full py-2.5 px-4 text-center bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition"
                >
                  Sign up
                </Link>
                <a
                  href="http://employer.indiahirings.com/login"
                  onClick={toggleSidebar}
                  className="block w-full py-2.5 px-4 text-center bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition"
                >
                  Employer Login
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow">
        <Outlet />
      </main>
    </div>
  );
}